import Building   from "./Building";
import City       from "./City";
import PostalCode from "./PostalCode";
import Prefecture from "./Prefecture";
import Street     from "./Street";

class Address {
  constructor(
    private readonly _postalCode: PostalCode = new PostalCode(),
    private readonly _prefecture: Prefecture = new Prefecture(),
    private readonly _city: City = new City(),
    private readonly _street: Street = new Street(),
    private readonly _building: Building = new Building()
  ) {
  }

  get postalCode() {
    return this._postalCode;
  }

  get prefecture() {
    return this._prefecture;
  }

  get city() {
    return this._city;
  }

  get street() {
    return this._street;
  }

  get building() {
    return this._building;
  }
}

export default Address;
